import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Heading, Text } from '@elseu/sdu-titan';
import React from 'react';
import styled, { css } from 'styled-components';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionPeople = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
});
var ContentWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-direction: row;\n      gap: ", ";\n    "], ["\n      flex-direction: row;\n      gap: ", ";\n    "])), theme.spacing[6]), media.greaterThan('m')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      gap: ", ";\n    "], ["\n      gap: ", ";\n    "])), theme.spacing[12]), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }));
});
var Header = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), media.greaterThan('s')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex: 0 0 250px;\n  "], ["\n    flex: 0 0 250px;\n  "]))), media.greaterThan('m')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex: 0 0 300px;\n  "], ["\n    flex: 0 0 300px;\n  "]))));
var PeopleContainer = styled.ul(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  list-style: none;\n  padding: 0;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  list-style: none;\n  padding: 0;\n\n  ", "\n"])), media.greaterThan('s')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  "], ["\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  "]))));
var Person = styled.li(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  word-break: break-word;\n  word-wrap: break-word;\n  hyphens: auto;\n\n  ", "\n"], ["\n  word-break: break-word;\n  word-wrap: break-word;\n  hyphens: auto;\n\n  ", "\n"])), media.greaterThan('s')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin: 0 auto;\n  "], ["\n    margin: 0 auto;\n  "]))));
var SectionPeople = function (_a) {
  var title = _a.title,
    description = _a.description,
    children = _a.children,
    name = _a.name,
    reference = _a.reference,
    background = _a.background;
  return jsx(StyledSectionPeople, {
    name: name,
    reference: reference,
    background: background,
    children: jsxs(ContentWrapper, {
      children: [jsxs(Header, {
        children: [title && jsx(Heading, {
          heading: "h3",
          renderAs: "h2",
          spaceAfter: 4,
          children: title
        }), description && jsx(Text, {
          as: "p",
          type: "paragraphLarge",
          children: description
        })]
      }), jsx(PeopleContainer, {
        children: React.Children.map(children, function (child, index) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            jsx(Person, {
              children: child
            }, index)
          );
        })
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;

export { SectionPeople, StyledSectionPeople };
//# sourceMappingURL=SectionPeople.js.map
